const layoutSizes = {
 sidebarWidth: 240,
 headerHeight: 72,
};
export default layoutSizes;
